import { OverlayViewMode } from '@1inch-community/models';
export const viewConfigDefault = {
    mode: OverlayViewMode.auto,
};
//# sourceMappingURL=overlay-view-config-default.js.map